import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { styled, useTheme } from '@mui/material/styles';
import styledComponents from "styled-components";
import axios from  "axios";
import {
    Box,
    Card,
    CardActions,
    CardContent,
    Grid,
    Typography,
    TextField,
    Button
  } from "@mui/material";

import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckIcon from '@mui/icons-material/Check';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import InventoryIcon from '@mui/icons-material/Inventory';
import PageviewIcon from '@mui/icons-material/Pageview';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import CampaignIcon from '@mui/icons-material/Campaign';
import WebIcon from '@mui/icons-material/Web';
import SellIcon from '@mui/icons-material/Sell';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

import preOrder from '../../assets/icons/preorder.png';
import adsMitra from '../../assets/icons/adsmitra.png';
import myStock from '../../assets/icons/mystock.png';
import nyaBar from '../../assets/icons/nyabar.png';
import priceList from '../../assets/icons/pricelist.png';
import readyStock from '../../assets/icons/Readystock.png';
import resi from '../../assets/icons/resi.png';
import subDb from '../../assets/icons/subDB.png';
import support from '../../assets/icons/support.png';
import katalog from '../../assets/icons/katalog.png';

import preorderImg from '../../assets/menu/preorder.png';
import readystokImg from '../../assets/menu/readystock.png';
import subdbImg from '../../assets/menu/submitra.png';
import mystockImg from '../../assets/menu/mystock.png';
import nyabarImg from '../../assets/menu/nabar.png';
import supportImg from '../../assets/menu/support_ticket.png';
import adsImg from '../../assets/menu/ads.png';
import katalogImg from '../../assets/menu/katalog.png';
import priceImg from '../../assets/menu/pricelist.png';
import resiImg from '../../assets/menu/resi.png';

// styles
const CardStyle = styled('p')(({ theme }) => ({
    background: theme.palette.mode === 'dark' ? theme.palette.dark[800] : theme.palette.primary.light,
    cursor: 'pointer',
    marginTop: '16px',
    marginBottom: '16px',
    overflow: 'hidden',
    position: 'relative',
    '&:after': {
        content: '""',
        position: 'absolute',
        width: '200px',
        height: '200px',
        border: '50px solid ',
        borderColor: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.primary.main,
        borderRadius: '50%',
        top: '30px',
        right: '-170px',
        opacity: '0.2'
    },
    '&:hover': {
        color: '#FFFFFF',
        background: theme.palette.mode === 'dark' ? theme.palette.dark[800] : theme.palette.primary.dark
    }
}));

const Container = styledComponents.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
`;

const MenuText = styledComponents.span`
    @media only screen and (max-width:600px) {
        font-size: 12px;
        font-weight: 700;
    }
`;

const ParagraphText = styled('div')(({ theme }) => ({
    position: 'absolute',
    width: '100%',
    fontSize: '24px',
    bottom: '15px',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    '@media only screen and (max-width:800px)': {
        fontSize: '18px'
    },
    '@media only screen and (max-width:640px)': {
        fontSize: '14px',
        bottom: '10px',
    },
    '@media only screen and (max-width:480px)': {
        fontSize: '11px',
        bottom: '8px',
    }
}));

const Main = () => {
    const navigate = useNavigate();
    return (
        <Container>
            <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                    <Grid container spacing={1}>
                        <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            // sx={{ position: 'relative' }}
                            onClick={() => navigate('/dashboard/po/list')}
                        >
                            <img src={preorderImg} width="100%" />
                            {/* <div
                                style={{
                                    position: 'absolute',
                                    backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                    height: '100%',
                                    width: '100%',
                                    color: 'white',
                                    textAlign: 'center',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                <ParagraphText>
                                    Fitur dalam masa development
                                </ParagraphText>
                            </div> */}
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} onClick={() => navigate('/dashboard/readystok')}>
                            <img src={readystokImg} width="100%" />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={12}>
                    <Grid container spacing={1}>
                        <Grid item xs={3} sm={3} md={3} lg={2} onClick={() => navigate('/dashboard/subdb')} align="center">
                            <img src={subdbImg} width="100%" />
                            <Typography variant="caption" color="rgb(92 153 248)">
                                Sub DB
                            </Typography>
                        </Grid>
                        <Grid item xs={3} sm={3} md={3} lg={2} align="center">
                            <img src={mystockImg} width="100%" />
                            <Typography variant="caption" color="rgb(92 153 248)">
                                My Stock
                            </Typography>
                        </Grid>
                        <Grid item xs={3} sm={3} md={3} lg={2} onClick={() => window.open('https://t.me/joinchat/HI-N0pw7f3rlIxKe', '_blank')} align="center">
                            <img src={nyabarImg} width="100%" />
                            <Typography variant="caption" color="rgb(92 153 248)">
                                Nyabar
                            </Typography>
                        </Grid>
                        <Grid item xs={3} sm={3} md={3} lg={2} onClick={() => navigate('/dashboard/support')} align="center">
                            <img src={supportImg} width="100%" />
                            <Typography variant="caption" color="rgb(92 153 248)">
                                Support Ticket
                            </Typography>
                        </Grid>
                        <Grid item xs={3} sm={3} md={3} lg={2} onClick={() => navigate('/dashboard/adsmitra')} align="center">
                            <img src={adsImg} width="100%" />
                            <Typography variant="caption" color="rgb(92 153 248)">
                                Ads Mitra
                            </Typography>
                        </Grid>
                        <Grid item xs={3} sm={3} md={3} lg={2} onClick={() => navigate('/dashboard/katalog')} align="center">
                            <img src={katalogImg} width="100%" />
                            <Typography variant="caption" color="rgb(92 153 248)">
                                Katalog
                            </Typography>
                        </Grid>
                        <Grid item xs={3} sm={3} md={3} lg={2} onClick={() => navigate('/dashboard/pricelist')} align="center">
                            <img src={priceImg} width="100%" />
                            <Typography variant="caption" color="rgb(92 153 248)">
                                Pricelist
                            </Typography>
                        </Grid>
                        <Grid item xs={3} sm={3} md={3} lg={2} onClick={() => navigate('/dashboard/resi')} align="center">
                            <img src={resiImg} width="100%" />
                            <Typography variant="caption" color="rgb(92 153 248)">
                                Resi
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    )
}

export default Main
